import Components from "../components";

class Toggle extends Components.Base {
  bind() {
    this.$el
      .find("[data-toggle-selector]")
      // Allows for nested toggles :)
      .not(this.$el.find(".c-toggle [data-toggle-selector]"))
      .on("click", this.onToggle.bind(this));
  }

  onToggle(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const $target = $(evt.target)
    const selector = $target.data("toggle-selector");
    const hideToggle = $target.data("hide-toggle");
    this.$el.find(selector).toggle();
    if(hideToggle) {
      $target.toggle();
    }

    const inputToggleSelector = $target.data("input-toggle-selector")
    if(inputToggleSelector) {
      const inputs = this.$el.find(inputToggleSelector)
      inputs.each(function () { this.checked = !this.checked; })
    }
  }
}

Components.collection.register({
  selector: '.c-toggle',
  klass: Toggle,
});
